<template>
  <div 
    class="entry"
    :class="{'setBorder': !lastEntry}"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  > 
    <div class="entry-content">
      <div class="entry-top">
        <div class="avatar-holder">
          <img
            class="avatar"
            :style="{ background: entry.user.avatar ? '' : entry.user.color }"
            :src="getAvatar(entry.user)"
          >
        </div>
        <div
          class="message"
          v-html="formatMessage(entry.message, entry.user.name)"
        />
      </div>
      <a class="tagline">
        {{ entry.tagline }}
      </a>
    </div>
    <!-- <a
      v-if="hover"
      class="delete-button"
      @click="deleteEntry"
    >
      <img src="@/assets/ico/close.svg">
    </a> -->
  </div>
</template>

<script>
import Constants from '@/components/Constants'
export default {
  name: 'CalendarBellPopupEntry',
  mixins: [Constants],
  props: {
    entry: Object,
    lastEntry: Boolean,
  },

  data() {
    return {
      hover: false,
    }
  },

  methods: {
    deleteEntry() {
      this.$emit('delete-entry',this.entry.id)
    },
    formatMessage(message, userName){
      return message.replace('<user>','<span class="notif-user-name">' + userName + '</span>')
    }
  },
}
</script>


<style lang="scss">
// global styles
.notif-user-name {
  @include font-rule('averta-bold');
}
</style>

<style scoped lang="scss">

.modal-wrapper {
  box-sizing: border-box;
  z-index: 3;
  border: 1px solid #ECEFF2;
  background-color: white;
  width: 338px;
  margin-top: 70px;
  position: absolute;
  height: 90%;
  align-self: flex-end;

  .setBorder {
    position: relative;
    border-bottom: 1px solid #EAEDF1;
  }

  .entry {
    display: flex;
    position: relative;
    flex-direction: row;

    .entry-content {
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      height: auto;
      align-content: flex-start;
      flex-direction: column;
    

      .entry-top {
        display:flex;
        align-items: flex-start;
        flex-direction: row;
        
        .avatar-holder {
          height: 24px;
          width: 24px;
          .avatar {
            height: 24px;
            width: 24px;
          }
        }


        .message {
          padding-left: 8px;
          padding-right: 26px;
          color: #161616;
          font-size: 14px;
          letter-spacing: 0.2px;
          line-height: 20px;
          font-weight: 100;
          word-break: break-word;
        }
      }

      .tagline {
        box-sizing: inherit;
        padding-left: 32px;
        width: 223px;
        color: #9093C0;
        font-size: 13px;
        letter-spacing: 0.2px;
        line-height: 20px;
      }
    }
  }

  .delete-button {
    position: absolute;
    top: 0px;
    right: 0;
    cursor: pointer;
    padding: 8px;
    line-height: 12px;
    &:focus {
      outline: none;
    }
    &:focus-visible {
      outline: 2px solid rgba($blue, 0.3);
    }
    &:hover {
      background-color: $white-lilac;
      img {
        opacity: 0.6;
      }
    }
    img {
    }
  }
}
</style>
